import Header from "../components/Header";

const CONTAINER = "mx-auto max-w-3xl px-6 py-16";
const H1 = "text-3xl font-semibold tracking-tight text-slate-900";
const H2 = "mt-10 text-xl font-semibold text-slate-900";
const P = "mt-3 text-sm leading-relaxed text-slate-700";

export default function LegalCookies() {
  return (
    <div className="min-h-screen bg-white" data-testid="legal-cookies-page">
      <Header />
      <main className={CONTAINER}>
        <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900" data-testid="legal-provisional-banner">
          <strong>Provisional version</strong> — this policy is a working draft.
        </div>
        <p className="text-xs font-semibold uppercase tracking-wider text-indigo-700">Legal</p>
        <h1 className={H1}>Cookie Policy</h1>
        <p className="mt-2 text-xs text-slate-500">Effective date: 07/30/2026</p>

        <h2 className={H2}>What are cookies?</h2>
        <p className={P}>
          Cookies are small text files stored in your browser when you visit a website. We use them
          only where strictly necessary to run Talent Junction.
        </p>

        <h2 className={H2}>Essential cookies (always on)</h2>
        <p className={P}>
          These cannot be disabled without breaking the service.
        </p>
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li><strong>Session / JWT token</strong> — stored in localStorage. Keeps you signed in.</li>
          <li><strong>CSRF token</strong> — protects form submissions against cross-site request forgery.</li>
          <li><strong>Stripe checkout cookies</strong> — set by Stripe on their checkout pages for fraud prevention (not by Talent Junction directly).</li>
        </ul>

        <h2 className={H2}>Analytics cookies (not yet active)</h2>
        <p className={P}>
          We do not currently use analytics or advertising cookies. If we add them, we will update
          this policy and ask for your consent through a banner.
        </p>

        <h2 className={H2}>Your choices</h2>
        <p className={P}>
          Most browsers let you delete existing cookies and refuse new ones. If you block essential
          cookies, some features (e.g. staying logged in) will stop working.
        </p>

        <h2 className={H2}>Contact</h2>
        <p className={P}>
          Questions? Email{" "}
          <a href="mailto:contact@talentjunction.io" className="text-indigo-700 hover:underline">contact@talentjunction.io</a>.
        </p>

        <p className="mt-10 text-xs text-slate-500">Last updated: 07/30/2026 · Provisional draft.</p>
      </main>
    </div>
  );
}
